import { themedUseStyletron } from '../../../theme/customTheme';


export function MotorIcon({ color, height, width }: any) {
    return (
        <svg version="1.0" width={width || '100%'} height={height || '100%'} viewBox="0 0 474.000000 284.000000"
        preserveAspectRatio="xMidYMid meet">
       
       <g transform="translate(0.000000,284.000000) scale(0.100000,-0.100000)"
       fill={color} stroke="none">
       <path d="M1360 2821 c-135 -53 -238 -164 -280 -300 -19 -60 -20 -96 -20 -827
       0 -748 0 -766 21 -826 23 -70 72 -147 121 -195 41 -40 141 -100 179 -108 l29
       -7 0 -88 0 -88 -44 -26 c-133 -78 -123 -273 19 -337 38 -18 97 -19 1229 -19
       l1190 0 44 21 c115 56 139 223 45 311 -16 15 -46 34 -68 41 l-40 14 -3 76 -3
       77 36 0 35 0 0 1150 0 1150 -1222 0 c-1146 -1 -1226 -2 -1268 -19z m2193 -341
       l0 -55 -1072 -3 -1071 -2 0 60 0 60 1071 -2 1072 -3 0 -55z m0 -270 l0 -55
       -1072 -3 -1071 -2 0 60 0 60 1071 -2 1072 -3 0 -55z m1 -282 l-2 -53 -1071 -3
       -1071 -2 0 55 0 55 1073 0 1072 0 -1 -52z m0 -300 l-2 -53 -1071 -3 -1071 -2
       0 55 0 55 1073 0 1072 0 -1 -52z m0 -316 l1 -52 -1072 0 -1073 0 0 55 0 55
       1071 -2 1071 -3 2 -53z m0 -299 l1 -53 -1072 0 -1073 0 0 55 0 55 1071 -2
       1071 -3 2 -52z"/>
       <path d="M3970 1689 l0 -1151 198 4 c170 4 205 8 257 27 125 45 236 153 287
       278 l23 58 3 759 c2 526 -1 776 -8 813 -29 135 -129 264 -255 328 l-60 30
       -222 3 -223 3 0 -1152z"/>
       <path d="M889 2626 c-69 -24 -120 -78 -139 -146 -6 -21 -10 -317 -10 -766 0
       -614 2 -738 15 -780 21 -73 90 -132 173 -147 l32 -7 0 930 c0 879 -1 930 -17
       930 -10 -1 -34 -7 -54 -14z"/>
       <path d="M538 1963 c-9 -10 -19 -28 -22 -40 -7 -22 -10 -22 -242 -25 -292 -4
       -274 7 -274 -167 0 -170 -16 -161 278 -161 l232 0 0 -29 c0 -17 10 -42 24 -58
       31 -36 95 -39 128 -5 22 22 23 28 23 241 0 201 -2 221 -19 240 -25 27 -105 30
       -128 4z"/>
       </g>
       </svg>
    );
}